var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.365 7.17031L16.0598 7.065C17.5487 6.83928 18.6493 5.55933 18.6493 4.05336C18.6493 2.54739 17.5487 1.26746 16.0598 1.04172L15.365 0.936412C11.5267 0.354529 7.62259 0.354529 3.78424 0.936412L3.08949 1.04172C1.60053 1.26744 0.5 2.54739 0.5 4.05336C0.5 5.55933 1.60053 6.83928 3.08949 7.065L3.78424 7.17031C7.62259 7.75219 11.5267 7.75219 15.365 7.17031Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 4.05367C12.5537 5.73691 13.9183 7.10146 15.6017 7.10146C17.285 7.10146 18.6496 5.73691 18.6496 4.05367C18.6496 2.37041 17.285 1.00586 15.6017 1.00586C13.9183 1.00586 12.5537 2.37041 12.5537 4.05367Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78424 11.83L3.08949 11.9353C1.60053 12.161 0.5 13.4409 0.5 14.947C0.5 16.4529 1.60053 17.7328 3.08949 17.9586L3.78424 18.0639C7.62259 18.6458 11.5267 18.6458 15.365 18.0639L16.0598 17.9586C17.5487 17.7328 18.6493 16.4529 18.6493 14.947C18.6493 13.4409 17.5487 12.161 16.0598 11.9353L15.365 11.83C11.5267 11.2481 7.62259 11.2481 3.78424 11.83Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.9463C0.5 16.6295 1.86463 17.9941 3.54797 17.9941C5.23131 17.9941 6.59593 16.6295 6.59593 14.9463C6.59593 13.263 5.23131 11.8984 3.54797 11.8984C1.86463 11.8984 0.5 13.263 0.5 14.9463Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ce57c6ce23dacec7f54052d389d9ca72.svg";
export { ForwardRef as ReactComponent };